import { render, staticRenderFns } from "./dragFormTree.vue?vue&type=template&id=0c1beba3&"
import script from "./dragFormTree.vue?vue&type=script&lang=js&"
export * from "./dragFormTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports